import { useState } from 'react';

const useEntityModals = () => {
  const [selected, setSelected] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [editModalMode, setEditModalMode] = useState('edit');
  const [editModalError, setEditModalError] = useState('');

  const openAddModal = () => {
    setSelected({});
    setEditModalMode('add');
    setIsEditModalOpen(true);

    setIsDeleteModalOpen(false);
    setIsInfoModalOpen(false);
  };

  const openEditModal = (item) => {
    setSelected(item);
    setEditModalMode('edit');
    setIsEditModalOpen(true);

    setIsDeleteModalOpen(false);
    setIsInfoModalOpen(false);
  };

  const openDeleteOrInfoModal = (item) => {
    setSelected(item);
    setIsEditModalOpen(false);
    setIsInfoModalOpen(false);

    !item?.postCount ? setIsDeleteModalOpen(true) : setIsInfoModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelected(null);
    setEditModalError('');
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelected(null);
  };

  const closeInfoModal = () => {
    setIsInfoModalOpen(false);
    setSelected(null);
  };

  const reset = () => {
    setSelected(null);
    setEditModalError('');
    setIsEditModalOpen(false);
    setIsDeleteModalOpen(false);
    setIsInfoModalOpen(false);
  };

  return {
    selected,
    isEditModalOpen,
    isDeleteModalOpen,
    isInfoModalOpen,
    editModalMode,
    editModalError,
    setEditModalError,
    openAddModal,
    openEditModal,
    closeEditModal,
    openDeleteOrInfoModal,
    closeDeleteModal,
    closeInfoModal,
    reset,
  };
};

export default useEntityModals;
